<template>
  <div
    :class="[`${color}`, 'rounded-xl h-full p-5 flex flex-col justify-between transition duration-100 cursor-pointer']">
    <div class="break-words mb-3">
      <p class="text-base text-white-900 uppercase">{{ title }}</p>
    </div>
    <div class="w-full flex justify-end">
      <p :class="[`${tamanhoH1}`, 'font-bold text-white-700']">{{ textValue }}</p>
    </div>
    <p class="text-sm" v-if="description">{{ description }}</p>
    <div v-if="objetivo">
      <p>Objetivo: {{ objetivo }}</p>
    </div>
  </div>
</template>

<script setup>
import { useFormat } from '@/composables/useFormat'
const { formatMoneyS } = useFormat()
import { ref, onMounted, watch } from 'vue'

const props = defineProps({
  color: String,
  description: String,
  divClass: String,
  objetivo: String,
  tamanhoH1: {
    type: String,
    default: 'text-6xl',
  },
  title: String,
  tooltipText: String,
  modelValue: Number,
  money: {
    type: Boolean,
    default: false,
  }
})

const textValue = ref(0)

const animateValue = (start, end, duration) => {
  let startTimestamp = null
  const step = (timestamp) => {
    if (!startTimestamp) startTimestamp = timestamp
    const progress = Math.min((timestamp - startTimestamp) / duration, 1)
    if (props.money) {
      textValue.value = formatMoneyS(progress * (end - start) + start)
    } else {
      textValue.value = Math.floor(progress * (end - start) + start)
    }
    if (progress < 1) {
      window.requestAnimationFrame(step)
    }
  }
  window.requestAnimationFrame(step)
}

onMounted(() => {
  animateValue(0, props.modelValue, 500)
})

watch(
  () => props.modelValue,
  (newVal) => {
    animateValue(0, newVal, 500)
  }
)

</script>
